module.exports = __webpack_public_path__ + "img/icon_search.ebd24296.svg";